import React from "react";
import MetaForm from "./MetaForm";

const TabAddMeta = () => {
  return (
    <div className="lg:w-1/2">
      <MetaForm />
    </div>
  );
};

export default TabAddMeta;
